import productViewShippingPricesHtml from './productviewstationarystoreavailabilities.html';
import './productviewstationarystoreavailabilities.scss';

class ProductViewStationaryStoreAvailabilitiesController {
    constructor($scope, $http) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.init = false;
        this.availability = {};
    }

    $onInit() {
        this.availabilities = JSON.parse(unescape(this.availabilities));
        this.init = true;
        this.availability = this.availabilities.variants.find(variant => variant.id === this.variantId);

        if (!this.availability) {
            this.availability = this.availabilities.product;
        }
    }

    save() {
    }

    availabilityQuestion() {
        this.close('availabilityQuestion');
    }

    buy() {
        this.close('buy');
    }

    close(returnData = null) {
        this.$scope.$parent.$ctrl.close(returnData);
    }
}

let productViewShippingPricesComponent  = {
    bindings: {
        availabilities: '@',
        variantId: '@',
        productName: '@',
        canBuy: '@'
    },
    template: productViewShippingPricesHtml,
    controller: ProductViewStationaryStoreAvailabilitiesController
}

export default productViewShippingPricesComponent;
